<template>
  <div>
    <el-button class="newAdd" @click="openDialog" size="mini">新建</el-button>
    <el-dialog
      title="新建"
      :visible.sync="moveDialogVisible"
      width="40%"
      center
      @close="clear"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="商户ID" prop="tenantId">
          <el-select
            v-model="form.tenantId"
            placeholder="请选择商户ID"
            clearable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="item in tabList"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="lang">
          <el-checkbox-group v-model="form.lang">
            <el-checkbox
              v-for="item in langArr"
              :label="item.labal"
              :key="item.value"
              >{{ item.value }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>

        <el-form-item
          prop="userId"
          v-for="item in form.lang"
          :key="item"
          :label="`${FINDLANGARR(item)}名称`"
        >
          <el-input v-model="form.nameMap[item]" class="searchIpt"></el-input>
        </el-form-item>

        <el-form-item
          v-for="(item, index) in form.lang"
          :key="index"
          :label="`${FINDLANGARR(item)}任务说明`"
          prop="inviteBy"
        >
          <el-input
            v-model="form.markMap[item]"
            class="searchIpt"
            autocomplete="off"
            type="textarea"
            :rows="5"
            placeholder="任务描述"
            maxlength="50"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="所属类别">
          <el-select
            v-model="form.activityTaskModuleType"
            placeholder="请选择所属类别"
            clearable
            @change="handleChange(form)"
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="(item, index) in taskTypeListOptions"
              :key="index"
              :label="item.activityModuleDesc"
              :value="item.activityModule"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="任务是否需按顺序完成">
          <el-radio-group v-model="form.radio">
            <el-radio label="1">是</el-radio>
            <el-radio label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item label="上架/下架时间">
          <el-date-picker
            size="mini"
            v-model="form.date"
            type="datetimerange"
            align="right"
            clearable
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="适用用户类型">
          <el-select
            v-model="form.activityUserTypeId"
            placeholder="请选择用户类型"
            clearable
            :style="{ width: '100%' }"
          >
            <el-option
              v-for="item in userTypeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="add">添加</el-button>
        <!-- <el-button size="mini" @click="clearFiled">重置</el-button> -->
      </span>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->

      <!-- <div>任务配置</div> -->

      <div class="task">
        <el-form :rules="taskRules" ref="taskForm">
          <div
            v-for="(fItem, fIndex) in form.tasks"
            :key="fIndex"
            class="taskBorder"
          >
            <div class="task_title">任务配置{{ fItem.level }}</div>
            <el-form-item
              prop="userId"
              v-for="(item, index) in form.lang"
              :key="index + item"
              :label="`${FINDLANGARR(item)}名称`"
            >
              <el-input
                v-model="fItem.nameMap[item]"
                class="searchIpt"
              ></el-input>
            </el-form-item>

            <el-form-item
              prop="inviteBy"
              v-for="(item, index) in form.lang"
              :key="index"
              :label="`${FINDLANGARR(item)}任务说明`"
            >
              <el-input
                v-model="fItem.markMap[item]"
                class="searchIpt"
              ></el-input>
            </el-form-item>
            <el-form-item label="任务内容">
              <el-select
                v-model="fItem.activityFieldCondition.conditionType"
                placeholder="请选择任务内容"
                clearable
                :style="{ width: '100%' }"
              >
                <el-option
                  v-for="(item, index) in logicOpListArr"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <div class="addTask">
                <el-button
                  size="mini"
                  type="primary"
                  @click="
                    handleAddTask(fItem.activityFieldCondition.children, false)
                  "
                  >添加任务</el-button
                >
                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="
                    handleAddTask(fItem.activityFieldCondition.children, true)
                  "
                  >添加逻辑任务</el-button
                > -->
                <!-- <el-button
                  size="mini"
                  type="primary"
                  @click="handleDelTask(fItem)"
                  >删除任务{{ fItem.name }}</el-button
                > -->
              </div>
              <!-- 儿子 -->
              <!-- <div
                class="flex mt12"
                v-for="(cItem, CIndex) in fItem.children"
                :key="CIndex + 'a'"
              >
                <el-select
                  v-model="cItem.activityLotteryId"
                  placeholder="请选择任务内容"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in taskTypeMap[
                      form.activityTaskModuleType
                    ]"
                    :key="index"
                    :label="item.activityTaskFieldDesc"
                    :value="item.activityTaskName"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-model="cItem.czf"
                  placeholder="请选择操作符"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in mathOpList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-select
                  v-model="cItem.coin"
                  placeholder="请选择币种"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in coinOptions2"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="cItem.taskTypeArgs"
                  class="searchIpt"
                  placeholder="数量"
                ></el-input>
                <div class="addTask">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="handleAddTask(cItem)"
                    >添加任务{{ cItem.name }}</el-button
                  >
                  <el-button size="mini" type="primary" @click="handleDelTask"
                    >删除任务{{ cItem.name }}</el-button
                  >
                </div>
              </div> -->
              <TaskList
                @handleAddTask="handleAddTask"
                @handleDelTask="handleDelTask"
                :fItem="fItem.activityFieldCondition"
                :activityTaskModuleType="form.activityTaskModuleType"
                :form="form"
              />
              <!-- <LogicTaskList
                @handleAddTask="handleAddTask"
                @handleDelTask="handleDelTask"
                :fItem="fItem"
                :form="form"
              /> -->
            </el-form-item>

            <!-- fitem -->
            <el-form-item prop="userId" label="奖励类型">
              <div class="flex">
                <el-select
                  v-model="fItem.activityLotteryId"
                  placeholder="请选择奖励金"
                  clearable
                  :style="{ width: '100%' }"
                >
                  <el-option
                    v-for="(item, index) in lotteryList"
                    :key="index"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="fItem.lotteryNum"
                  class="searchIpt"
                  placeholder="数量"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item prop="userId" label="最大奖励数量">
              <el-input
                v-model="fItem.maxLotteryAmount"
                class="searchIpt"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <el-button size="mini" type="primary" @click="handleAdd()" class="mb12"
          >添加任务配置</el-button
        >
        <el-button size="mini" type="primary" @click="handledel()" class="mb12"
          >删除任务配置</el-button
        >
      </div>
    </el-dialog>
    <!-- 选择任务 -->
    <el-dialog
      title="管理"
      :visible.sync="chooseTaskVisible"
      width="40%"
      center
      @close="closeChooseTaskVisible"
    >
      <el-select
        size="mini"
        :rules="[{ required: true, message: '请选择', trigger: 'change' }]"
        v-model="activityTaskFieldDesc"
        placeholder="选择任务"
      >
        <!-- <el-option label="全部仓位模式" value=""> </el-option> -->
        <el-option
          v-for="(item, index) in taskTypeMap[form.activityTaskModuleType]"
          :key="index"
          :label="item.activityTaskFieldDesc"
          :value="item.activityTaskName"
        >
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" type="primary" @click="closeChooseTaskVisible"
          >关闭</el-button
        >
        <el-button size="mini" type="primary" @click="handleChooseTaskVisible"
          >确认</el-button
        >

        <!-- <el-button size="mini" @click="clearFiled">重置</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import moment from 'moment'
import { LANGARR, FINDLANGARR } from '../../constants'
import TaskList from '../taskList.vue'
import LogicTaskList from '../LogicTaskList/index.vue'
export default {
  props: ['tabList'],

  components: {
    TaskList,
    LogicTaskList,
  },
  data() {
    return {
      moveDialogVisible: false,
      detailInfo: null,
      isAct: false,
      form: {
        tenantId: '',
        lang: ['zh'],
        date: '',
        nameMap: {
          zh: '',
        },
        markMap: { zh: '' },
        activityTaskModuleType: 'Fisher',
        activityUserTypeId: 1,
        tasks: [
          {
            // name: Date.now() + "_" + "1",
            name: '1_1',
            level: 1,
            nameMap: {
              zh: '',
            },
            markMap: { zh: '' },

            activityLotteryId: '', //奖励类型
            lotteryNum: '', //奖励数量
            maxLotteryAmount: '', //最大奖励数量
            activityFieldCondition: {
              conditionType: '',
              isLogic: true,
              children: [
                {
                  level: '1_1',
                  //   activityLotteryId: '',
                  //  lotteryNum: '',
                  //  maxLotteryAmount: '',
                  isLogic: false,
                  conditionType: '',
                  // coin: 0,
                  taskTypeArgs: '',
                  children: [
                    // {
                    //   activityLotteryId: '',
                    //   lotteryNum: '',
                    //   maxLotteryAmount: '',
                    //   children: [],
                    // },
                  ],
                },
              ],
            },
            // children: [
            //   {
            //     level: '1_1',
            //     activityLotteryId: '',
            //     lotteryNum: '',
            //     maxLotteryAmount: '',
            //     isLogic: '',

            //     coin: 0,
            //     children: [
            //       // {
            //       //   activityLotteryId: '',
            //       //   lotteryNum: '',
            //       //   maxLotteryAmount: '',
            //       //   children: [],
            //       // },
            //     ],
            //   },
            // ],
          },
          // {
          //   name: "one",
          //   nameMap: {
          //     zh: "",
          //     en: "",
          //     ja: "",
          //   },
          //   markMap: { zh: "", en: "", ja: "" },
          //   isLogic: "",
          //   conditionType: "",
          //   activityLotteryId: "", //奖励类型
          //   lotteryNum: "", //奖励数量
          //   maxLotteryAmount: "", //最大奖励数量
          //   children: [
          //     {
          //       activityLotteryId: "",
          //       lotteryNum: "",
          //       maxLotteryAmount: "",
          //       isLogic: "",
          //       children: [
          //         {
          //           activityLotteryId: "",
          //           lotteryNum: "",
          //           maxLotteryAmount: "",
          //           children: [],
          //         },
          //       ],
          //     },
          //   ],
          // },
        ],
      },

      taskForm: {
        nameMap: {
          zh: '',
          en: '',
          ja: '',
        },
        markMap: { zh: '', en: '', ja: '' },
        isLogic: '',
        conditionType: '',
        activityLotteryId: '', //奖励类型
        lotteryNum: '', //奖励数量
        maxLotteryAmount: '', //最大奖励数量
        children: [
          {
            activityLotteryId: '',
            lotteryNum: '',
            maxLotteryAmount: '',
            isLogic: '',
            children: [
              {
                activityLotteryId: '',
                lotteryNum: '',
                maxLotteryAmount: '',
                children: [],
              },
            ],
          },
        ],
      },

      langArr: LANGARR,
      formLabelWidth: 'auto',
      rules: {
        // userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        // inviteBy: [
        //   { required: true, message: '请输入合伙人UID', trigger: 'blur' },
        // ],
        // rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        // otcRate: [
        //   { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        // ],
      },
      taskRules: {
        // userId: [{ required: true, message: '请输入UID', trigger: 'blur' }],
        // inviteBy: [
        //   { required: true, message: '请输入合伙人UID', trigger: 'blur' },
        // ],
        // rate: [{ required: true, message: '请输入比例', trigger: 'blur' }],
        // otcRate: [
        //   { required: true, message: '请输入otcRate返佣比例', trigger: 'blur' },
        // ],
      },

      currentLang: '',

      coinOptions2: [
        {
          label: 'USDT',
          value: 0,
        },
      ],
      chooseTaskVisible: false,
      activityTaskFieldDesc: '',
      level: 1,
    }
  },
  watch: {
    'form.tenantId': {
      handler(val, oldVal) {
        if (!val) {
          return
        }
        if (val !== oldVal) {
          this.getLotteryList({ tenantId: val })
          this.getUserTypeList({ tenantId: val })
        }
      },
      // immediate: true,
      deep: true,
    },
  },
  computed: {
    ...mapState('management', [
      'taskTypeList',
      'mathOpList',
      'lotteryList',
      'userTypeList',
    ]),
    ...mapGetters('management', [
      'taskTypeListOptions',
      'taskTypeMap',
      'logicOpListArr',
    ]),
  },

  methods: {
    ...mapActions('management', [
      'addLottery',
      'getUserData',
      'getLotteryList',
      'getUserTypeList',
    ]),
    FINDLANGARR,
    handleChange(form) {
      form.tasks.forEach((item) => {
        item.activityFieldCondition.children[0].activityTaskType = ''
      })
    },

    setCurrentLang(item) {
      this.currentLang = this.form.lang[0]
    },
    handleAddTask(item, isLogic) {
      // const currentIndex = this.oprterItem(item, this.form.tasks, "find");
      // if (currentIndex == -1) {
      //   return;
      // }

      this.oprterItem(item, this.form.tasks, 'add', isLogic)
      this.activityTaskFieldDesc = ''
      // this.chooseTaskVisible = true;
    },
    oprterItem(item, arr = [], type, isLogic) {
      const that = this
      if (this.form.tasks.length == 0) {
        return -1
      }

      if (type == 'add') {
        item.push({
          // name: Date.now() + "_" + (Number(subItem.level) + 1),
          // name: Number(item.level) + 1 + '_' + (item.length + 1) + '_',
          conditionType: '',

          isLogic: isLogic,

          coin: 0,
          children: [],
          //level: Number(item.level) + 1,
        })
        this.$forceUpdate()
        return
      }

      // const len = arr.length;
      // console.log("arr", arr);
      // if (type == "find") {
      //   for (let i = 0; i < len; i++) {
      //     let subItem = arr[i];
      //     if (subItem.name == item.name) {
      //       return i;
      //     }
      //     if (subItem && subItem.children && subItem.children.length > 0) {
      //       return this.oprterItem(item, subItem.children, "find");
      //     }
      //   }
      //   return -1;
      // }
      // if (type == "add") {
      //   for (let i = 0; i < len; i++) {
      //     let subItem = arr[i];
      //     console.log("subItem", subItem);
      //     if (subItem.name == item.name) {
      //       subItem.children.push({
      //         // name: Date.now() + "_" + (Number(subItem.level) + 1),
      //         name:
      //           Number(subItem.level) +
      //           1 +
      //           "_" +
      //           (subItem.children.length + 1) +
      //           "_" +
      //           Date.now(),
      //         activityLotteryId: "",
      //         lotteryNum: "",
      //         maxLotteryAmount: "",
      //         czf: "",
      //         coin: "",
      //         taskTypeArgs: "",
      //         children: [],
      //         level: Number(subItem.level) + 1,
      //       });
      //       this.$forceUpdate();
      //       return;
      //     }
      //     if (subItem && subItem.children && subItem.children.length > 0) {
      //       that.oprterItem(item, subItem.children, "add");
      //     }
      //   }
      // }
    },
    handleDelTask(item, index, arr = []) {
      arr.splice(index, 1)
      arr = [...arr]
      this.$forceUpdate()
      return
      console.log('item', item)
      console.log('item.name', item.name)
      // const that = this;
      // if (this.form.tasks.length == 0) {
      //   return -1;
      // }

      // const len = arr.length;
      // for (let i = 0; i < len; i++) {
      //   let subItem = arr[i];
      //   console.log("subItem", subItem);
      //   console.log("subItem.name ", subItem.name);
      //   if (subItem.name == item.name) {
      //     arr.splice(i, 1);
      //     // arr = [...arr];
      //     this.$forceUpdate();
      //     return;
      //   }
      //   if (subItem && subItem.children && subItem.children.length > 0) {
      //     return that.handleDelTask(item, subItem.children);
      //   }
      // }
    },
    openDialog() {
      this.moveDialogVisible = true
    },

    closeChooseTaskVisible() {
      this.chooseTaskVisible = false
    },
    handleChooseTaskVisible() {
      this.form.tasks[0].children.activityTaskType = this.activityTaskType
      this.chooseTaskVisible = false
    },

    traverseObject(obj, path = []) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const currentPath = [...path, key]
          const value = obj[key]

          // 检查当前值是否为空（你可以根据需要调整这个条件）
          if (value === null || value === undefined || value === '') {
            this.$message.error('请输入完整信息')
            return true // 停止遍历
          }

          // 如果当前值是对象或数组，则递归遍历
          if (typeof value === 'object' && value !== null) {
            if (this.traverseObject(value, currentPath)) {
              return true // 如果递归调用返回 true，则停止遍历
            }
          }
        }
      }
      return false // 没有找到空值
    },
    add() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          if (this.traverseObject(this.form)) {
            return
          }
          const data = {
            ...this.form,

            startTime: this.form.date
              ? moment(this.form.date[0]).valueOf()
              : '',
            endTime: this.form.date ? moment(this.form.date[1]).valueOf() : '',
          }

          this.addLottery(data).then((res) => {
            if (res.code == 0) {
              this.$message.success('添加成功')
              this.$emit('refresh', { tenantId: this.form.tenantId })
              this.clear()
            } else {
              this.$message.error('添加失败')
              this.clear()
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    clearFiled() {
      this.$refs['form'].resetFields()
    },
    handleAdd() {
      this.form.tasks.push({
        // name: Date.now() + "_" + "1",
        name: '1_1',
        level: ++this.level,
        nameMap: {
          zh: '',
        },
        markMap: { zh: '' },

        activityLotteryId: '', //奖励类型
        lotteryNum: '', //奖励数量
        maxLotteryAmount: '', //最大奖励数量
        activityFieldCondition: {
          conditionType: '',
          isLogic: true,
          children: [
            {
              level: '1_1',
              //  activityLotteryId: '',
              //  lotteryNum: '',
              //  maxLotteryAmount: '',
              isLogic: false,
              conditionType: '',
              taskTypeArgs: '',
              // coin: 0,
              children: [
                // {
                //   activityLotteryId: '',
                //   lotteryNum: '',
                //   maxLotteryAmount: '',
                //   children: [],
                // },
              ],
            },
          ],
        },
      })
    },
    handledel() {
      if (this.level > 1) {
        this.form.tasks.pop()
        this.level--
      }
    },
    clear() {
      this.$refs['form'].resetFields()
      ;(this.form = {
        tenantId: '',
        lang: ['zh'],
        date: '',
        nameMap: {
          zh: '',
        },
        markMap: { zh: '' },
        activityTaskModuleType: 'Fisher',
        activityUserTypeId: 1,
        tasks: [
          {
            // name: Date.now() + "_" + "1",
            name: '1_1',
            level: 1,
            nameMap: {
              zh: '',
            },
            markMap: { zh: '' },
            activityLotteryId: '', //奖励类型
            lotteryNum: '', //奖励数量
            maxLotteryAmount: '', //最大奖励数量
            activityFieldCondition: {
              conditionType: '',
              isLogic: true,
              children: [
                {
                  level: '1_1',
                  //activityLotteryId: '',
                  //  lotteryNum: '',
                  // maxLotteryAmount: '',
                  isLogic: false,
                  taskTypeArgs: '',
                  conditionType: '',
                  activityTaskType: '',
                  // coin: 0,
                  children: [],
                },
              ],
            },
          },
        ],
      }),
        (this.moveDialogVisible = false)
    },
  },
}
</script>

<style lang="less" src="@/styles/button.less" scoped>
.content {
  // border: 1px solid #f5f6f7;
  padding: 20px;
  width: 100%;
  height: 200px;
  .up {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
  }
  .down {
    border: 1px solid #f5f6f7;
    width: 100%;
    height: 50%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .item {
    border-right: 1px solid #f5f6f7;
    display: flex;
    width: 50%;
    height: 100%;
    justify-content: center;
    align-items: center;
    .ipt {
      width: 90%;
    }
  }
}
.btn1 {
  display: flex;
  justify-content: center;
  width: 300px;
  margin: 0 auto;
}
</style>
<style lang="less" scoped>
.langTab {
  cursor: pointer;
  margin-right: 20px;
  display: inline-block;
}
.task {
}
.task_title {
  font-size: 18px;
  color: #707aff;
  font-weight: 700;
}
.taskBorder {
  border: 1px solid #000;
  padding: 12px;
  margin-bottom: 20px;
}
.flex {
  display: flex;
  gap: 12px;
  align-items: center;
}
.mt12 {
  margin-top: 12px;
}
.mb12 {
  margin-bottom: 12px;
}
.addTask {
}
</style>
